export function manageParameters() {

    //check if there are parameters in url
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let lid = params.get('lid');

    if (lid !== null) {
        sessionStorage.setItem("lid", lid);
    } else {
        //getting back from cognito?
        if (params.get('code') !== null
            && params.get('state') !== null) {
            //yes

        } else {
            sessionStorage.removeItem("lid");

        }
    }
}

export function getParameterLid() {
    return sessionStorage.getItem("lid");
}

